export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl overflow-hidden p-8 md:p-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">移动阅读，随时随地追漫</h2>
            <p className="mt-3 text-sm text-background-50/80 leading-relaxed max-w-lg mx-auto lg:mx-0">
              YY漫画移动端完美适配手机屏幕，下拉式阅读体验在手机上更加流畅。无论是在地铁上、午休时还是睡前，打开即读，追漫不等待。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 text-background-50 text-sm">
                <i className="ri-smartphone-line text-lg"></i>
                <span className="whitespace-nowrap">iOS / Android</span>
              </div>
              <div className="flex items-center gap-2 text-background-50 text-sm">
                <i className="ri-speed-line text-lg"></i>
                <span className="whitespace-nowrap">流畅下拉式阅读</span>
              </div>
              <div className="flex items-center gap-2 text-background-50 text-sm">
                <i className="ri-notification-3-line text-lg"></i>
                <span className="whitespace-nowrap">实时更新推送</span>
              </div>
            </div>
            <div className="mt-6">
              <a href="#hero" className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-600 font-semibold rounded-full hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap text-sm">
                <i className="ri-download-line"></i> 立即体验
              </a>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[320px] aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/30">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20mobile%20phone%20mockup%20showing%20a%20manga%20reading%20app%20interface%20with%20colorful%20comic%20panels%20on%20screen%2C%20warm%20inviting%20interface%20colors%2C%20modern%20UI%20design%2C%20professional%20product%20presentation%20style%2C%20soft%20lighting%2C%20cream%20and%20warm%20orange%20accents%2C%20no%20text%20visible&width=640&height=1136&seq=app-mockup-01&orientation=portrait"
                alt="YY漫画移动端 - 手机漫画阅读体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}